import { createAsyncThunkFromFetch } from 'src/store/utils';
import {
  ActiveHeadsetSubscription,
  Headset,
  HeadsetActivationCode,
  HeadsetComment,
  HeadsetEventsResponse,
  HeadsetInvoice,
  HeadsetMeta,
  HeadsetSubscription,
  HeadsetUserEvent,
  NewHeadsetComment,
} from 'src/models';
import {
  addHeadsetCommentAPI,
  deleteCustomerSessionAPI,
  deleteHeadsetAPI,
  deleteHeadsetCommentAPI,
  getHeadset,
  getHeadsetActivationCode,
  getHeadsetCommentsAPI,
  getHeadsetEvents,
  getHeadsetMetaAPI,
  getHeadsetPayments,
  getHeadsets,
  getHeadsetSubscriptions,
  getHeadsetUserEvents,
  headsetActivateSubscription,
  headsetCancelActiveSession,
  headsetCancelAllActiveSubscription,
  updateHeadset,
} from './headsets.api';

const prefix = 'headsets';

export const fetchHeadsetActivationCodeAction = createAsyncThunkFromFetch<
  HeadsetActivationCode,
  { companyId: string }
>(`${prefix}/fetchHeadsetActivationCode`, getHeadsetActivationCode);

export const fetchHeadsetsAction = createAsyncThunkFromFetch<
  Headset[],
  {
    companyId: string;
    query?: string;
    withoutIndication?: boolean;
    uuid: string;
  }
>(`${prefix}/fetchHeadsets`, getHeadsets);
export const fetchHeadsetAction = createAsyncThunkFromFetch<
  Headset,
  { companyId: string; headsetId: string }
>(`${prefix}/fetchHeadset`, getHeadset);

export const saveHeadsetAction = createAsyncThunkFromFetch<
  Headset,
  { companyId: string; headsetId: string; data: Partial<Headset> }
>(`${prefix}/saveHeadset`, updateHeadset);

export const deleteHeadsetAction = createAsyncThunkFromFetch<
  void,
  { companyId: string; headsetId: string }
>(`${prefix}/deleteHeadset`, deleteHeadsetAPI);

export const activateHeadsetSubscriptionAction = createAsyncThunkFromFetch<
  ActiveHeadsetSubscription,
  { companyId: string; headsetId: string; data: { packageId: string } }
>(`${prefix}/activateHeadsetSubscription`, headsetActivateSubscription);

export const cancelHeadsetActiveSubscriptionAction = createAsyncThunkFromFetch<
  Headset,
  { companyId: string; headsetId: string }
>(
  `${prefix}/cancelHeadsetActiveSubscription`,
  headsetCancelAllActiveSubscription,
);

export const cancelHeadsetActiveSessionAction = createAsyncThunkFromFetch<
  undefined,
  { companyId: string; headsetId: string }
>(`${prefix}/headsetCancelActiveSession`, headsetCancelActiveSession);

export const fetchHeadsetPaymentsAction = createAsyncThunkFromFetch<
  HeadsetInvoice[],
  { companyId: string; headsetId: string }
>(`${prefix}/fetchHeadsetPayments`, getHeadsetPayments);

export const fetchHeadsetSubscriptionsAction = createAsyncThunkFromFetch<
  HeadsetSubscription[],
  { companyId: string; headsetId: string }
>(`${prefix}/fetchHeadsetSubscriptions`, getHeadsetSubscriptions);

export const fetchHeadsetUserEventsAction = createAsyncThunkFromFetch<
  HeadsetUserEvent[],
  { companyId: string; headsetId: string }
>(`${prefix}/fetchHeadsetUserEvents`, getHeadsetUserEvents);

export const fetchHeadsetEventsAction = createAsyncThunkFromFetch<
  HeadsetEventsResponse,
  {
    companyId: string;
    headsetId: string;
    params?: {
      start?: string;
      end?: string;
    };
  }
>(`${prefix}/fetchHeadsetEvents`, getHeadsetEvents);

export const fetchHeadsetCommentsAction = createAsyncThunkFromFetch<
  HeadsetComment[],
  {
    companyId: string;
    headsetId: string;
    params?: {
      start?: string;
      end?: string;
    };
  }
>(`${prefix}/fetchHeadsetComments`, getHeadsetCommentsAPI);
export const fetchHeadsetMetaAction = createAsyncThunkFromFetch<
  HeadsetMeta,
  {
    companyId: string;
    headsetId: string;
  }
>(`${prefix}/fetchHeadsetMeta`, getHeadsetMetaAPI);
export const addHeadsetCommentAction = createAsyncThunkFromFetch<
  HeadsetComment,
  {
    companyId: string;
    headsetId: string;
    data: NewHeadsetComment;
  }
>(`${prefix}/addHeadsetComment`, addHeadsetCommentAPI);
export const deleteHeadsetCommentAction = createAsyncThunkFromFetch<
  void,
  {
    companyId: string;
    headsetId: string;
    commentId: string;
  }
>(`${prefix}/deleteHeadsetComments`, deleteHeadsetCommentAPI);

export const deleteCustomerSessionAction = createAsyncThunkFromFetch<
  { result: boolean },
  { companyId: string; headsetId: string }
>(`${prefix}/deleteCustomerSession`, deleteCustomerSessionAPI);
